module.exports = __webpack_public_path__ + "img/enterprise.2cff9c47.png";